//Splide Legipedia
import Splide from "@splidejs/splide";
const classExists = document.getElementsByClassName('legipedia').length > 0;

if (classExists) {
    var splide = new Splide('.legipedia', {
        //type   : 'loop',
        drag: 'free',
        focus: 'center',
        perPage: 1,
        pagination: true,
        lazyLoad: 'nearby',
        drag: true,
    });

    splide.mount();
}
